import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';


export function ContactSelector({ selectedCustomer, selectedContact, onContactChange }) {
  if (!selectedCustomer) {
    return (
      <div className="space-y-2">
        <Label htmlFor="contact-person">Contact Person</Label>
        <div className="glass-input px-3 py-2 bg-muted/20 text-muted-foreground">
          No customer selected
        </div>
      </div>
    );
  }

  if (!selectedCustomer.contacts || selectedCustomer.contacts.length === 0) {
    return (
      <div className="space-y-2">
        <Label htmlFor="contact-person">Contact Person</Label>
        <div className="glass-input px-3 py-2 bg-muted/20 text-muted-foreground">
          {selectedCustomer.contactPerson || 'No contact available'}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2 mt-[0px] mr-[0px] mb-[14px] ml-[0px]">
      <Label htmlFor="contact-person">Contact Person</Label>
      <Select
        value={selectedContact}
        onValueChange={onContactChange}
      >
        <SelectTrigger className="glass-input">
          <SelectValue placeholder="Select a contact person" />
        </SelectTrigger>
        <SelectContent>
          {selectedCustomer.contacts.length> 0 && selectedCustomer.contacts.map((contact) => (
            <SelectItem key={contact.person_id} value={contact.person_id}>
              <div className="flex items-center w-full gap-4">
                <span className="font-medium">{contact.first_name} {contact.last_name}</span>
                <span className="text-xs text-muted-foreground">{contact.email}</span>
                <span className="text-xs text-muted-foreground">{contact.phone_number}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}